import { gql } from '@apollo/client';

export const DASHBOARD_DATA = gql`
  query DashboardData($input: FilterArgs) {
    totalPlannedSessions(input: $input)
    totalProvinces(input: $input)
    totalInterventionTypes(input: $input)
    totalBeneficiaries(input: $input)
    totalServiceProviders(input: $input)
    totalInstitutions(input: $input)
    totalDistricts(input: $input)
  }
`;
